<script lang="ts">

  import { onMount } from "svelte";
  import { init } from "./init";
  import { SliderElement } from "./SliderElement";
  import { SliderHost } from "./SliderHost";

  export let id: string;
  export let wrapperId: string;
  export let minLabel: string;
  export let maxLabel: string;
  export let minValue: string;
  export let maxValue: string;
  export let facetName: string;
  export let initialMinValue: string;
  export let initialMaxValue: string;
  export let availablePreselects: string;
  export let logarithmic: string;
  export let delayedActionMillis: string;
  export let showDefaultPlaceholders: string;
  export let focusFloatsBothLabels: string;
  let container: HTMLElement;

  onMount(() => {
    init(container, SliderHost, SliderElement);
  })
</script>
<div id={wrapperId}
     class="heureka_slider__wrapper">
  <div class="heureka_slider" bind:this={container}
       id={id}
       data-slider-min-label={minLabel}
       data-slider-max-label={maxLabel}
       data-slider-min-val={minValue}
       data-slider-max-val={maxValue}
       data-facet-name={facetName}
       data-heureka-slider-initial-min-value={initialMinValue}
       data-heureka-slider-initial-max-value={initialMaxValue}
       data-heureka-slider-available-preselects={availablePreselects}
       data-slider-logarithmic={logarithmic}
       data-delayed-action-millis={delayedActionMillis}
       data-slider-show-default-placeholders={showDefaultPlaceholders}
       data-slider-focus-floats-both-labels={focusFloatsBothLabels}
  ></div>
</div>